import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "ProfileEdit" })
export default class ProfileEdit extends Vue {
    public localizer: any = Localizer;
    public isLoading: boolean = false;
    public isSuccess: boolean = false;
    public formData: any = {};
    public validationErrors: any[] = [];

    @Prop() readonly returnUrl: string;

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        await this.getData();
    }

    public async getData() {
        this.formData = (await Axios.post(this.routes.Customer_GetProfileEditData, null)).data;
    }

    public async submitForm() {
        this.validationErrors = [];

        this.isLoading = true;

        try {
            let result = (await Axios.post(this.routes.Customer_ProfileEdit, this.formData)).data;

            this.isSuccess = true;

            window.location.href = result.redirectUrl ? result.redirectUrl : (this.returnUrl ? this.returnUrl : "/");
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoading = false;
    }

    public isValidationError(controlName: string): boolean {
        return FormHelper.isControlValidationError(controlName, this.validationErrors);
    }
};